const currencies = {
  EUR: 1,
  CAD: 0.639048,
  GBP: 1.09149,
  CHF: 0.927779,
  USD: 0.843663
};
export default currencies;
